export enum EVerificationCodeStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
}